import {
  observable,
  runInAction,
  computed,
  action,
} from 'mobx';
import logger from '../utils/logger';

class HaulerStore {
  @observable
    _haulers = null;
  @observable
    isLoading = false;
  @observable
    error = null;

  get api() {
    return this.rootStore.newAuthStore;
  }

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @computed
  get haulers() {
    // Fetch haulers if they are not already fetched
    if (!this._haulers) {
      this.fetchHaulers();
    }
    return this._haulers || [];
  }

  @action
    fetchHaulers = async () => {
      if (this.isLoading || this._haulers !== null) {
      // Already fetching or fetched
        return;
      }

      this.isLoading = true;
      this.error = null;
      const url = '/api/hauler';
      try {
      // First – Use locally stored data if available
        await this.api.storeDB.init();
        const localData = await this.api.storeDB.getByKey(url);

        runInAction(() => {
          if (localData) {
            this._haulers = localData;
          }
        });

        // Then – Fetch data from the server
        const serverData = await this.api.makeAuthorizedRequest(url);

        runInAction(() => {
          this._haulers = serverData;
        });
      } catch (error) {
        logger.error(error);
        runInAction(() => {
          this.error = error;
        });
      } finally {
        runInAction(() => {
          this.isLoading = false;
        });
      }
    };

  @action
    invalidateHaulers = () => {
      this._haulers = null;
    };
}

export default HaulerStore;
